<div class="row">
  <div class="col-xs-12 col-12">
    <pagination [disabled]="disabled" [totalItems]="66"></pagination>
  </div>
</div>

<button type="button" class="btn btn-info" (click)="toggleState()">Toggle state</button>
